import React from 'react';
import WeLoveCard from "./WeLoveCard";

export default [
  {
    id: 1,
    image: 'stl-1.jpg',
    annotations: [{
      id: 1,
      xCoordinate: 0.3,
      yCoordinate: 0.25,
      product: {
        id: 122718,
        link: '/products/traditional-wallpaper-roll-terracotta-swallows-122718?collection_id=215',
        title: 'Traditional Wallpaper Roll in Terracotta Swallows',
        image: 'https://th3insid3.s3.amazonaws.com/tmp/phpnDGAmn/iCjiIl96WxxhUuZ5WzRC6CbhbB2bK52teJacPIwn.jpg',
      }
    },
      {
        id: 2,
        xCoordinate: 0.55,
        yCoordinate: 0.35,
        product: {
          id: 60919,
          link: '/products/velvet-privacy-curtain-50-x-108-pacific-performance-velvet-60919',
          title: 'Velvet Privacy Curtain in Pacific Performance Velvet',
          image: 'https://th3insid3.s3.amazonaws.com/tmp/phpmNPNnC/rrGNMH79ElpKH1dUWFNZeQ5nVG0Nz6NgstyeSlw0.jpg',
        }
      },
      {
        id: 3,
        xCoordinate: 0.25,
        yCoordinate: 0.75,
        product: {
          id: 57132,
          link: 'products/skirted-platform-bed-queen-terracotta-swallows-57132',
          title: 'Skirted Platform Bed in Terracotta Swallows',
          image: 'https://th3insid3.s3.amazonaws.com/tmp/phpmddKhO/xJkK1AovGBlRNgTzKhXk75Seoa98iftW69JOjRYZ.jpg',
        }
      }
    ]
  },
  {
    id: 2,
    image: 'stl-2.jpg',
    annotations: [{
      id: 4,
      xCoordinate: 0.65,
      yCoordinate: 0.64,
      product: {
        id: 42038,
        link: '/products/throw-pillow-18-desert-cheetah-by-scalamandre-42038',
        title: 'Throw Pillow 18" in Desert Cheetah by Scalamandré',
        image: 'https://theinside.imgix.net/products/xHWTcYSnS0Qf4vI4Dh1m9HrO4gL1avVACBDxIBB5.jpg',
      }
    },
      {
        id: 5,
        xCoordinate: 0.8,
        yCoordinate: 0.56,
        product: {
          id: 44149,
          link: '/products/bun-foot-accent-chair-sheepskin-natural-legs-44149',
          title: 'Bun Foot Accent Chair in Sheepskin',
          image: 'https://th3insid3.s3.amazonaws.com/tmp/phpJhcILF/HihD5gqdd9PoWihC0Ao2YDHBNq1QPGwGcnceYUIq.jpg',
        }
      },
      ]
  },
  {
    id: 3,
    component: <WeLoveCard />
  },
  {
    id: 4,
    image: 'stl-4.jpg',
    annotations: [{
      id: 6,
      xCoordinate: 0.4,
      yCoordinate: 0.58,
      product: {
        id: 48225,
        link: '/products/x-bench-leopard-48225',
        title: 'X Bench in Leopard',
        image: 'https://th3insid3.s3.amazonaws.com/tmp/phphHHEHp/c2la8OeBERKXr3XOmimeIe6EpjyKMgNg7ePM5vY3.jpg',
      }
    }]
  },
  {
    id: 5,
    image: 'stl-5.jpg',
    annotations: [{
      id: 7,
      xCoordinate: 0.1,
      yCoordinate: 0.4,
      product: {
        id: 46310,
        link: '/products/throw-pillow-14-x-20-nutmeg-luxe-velvet-46310',
        title: 'Throw Pillow 14" x 20" in Nutmeg Luxe Velvet',
        image: 'https://th3insid3.s3.amazonaws.com/tmp/phpFCkDgi/hhRIrt0IFQMzldbsQ5PvVl7H3FhOGQpMsLFZvxCs.jpg',
      }
    },
      {
        id: 8,
        xCoordinate: 0.3,
        yCoordinate: 0.35,
        product: {
          id: 50530,
          link: '/products/throw-pillow-20-canvas-tigresse-50530',
          title: 'Throw Pillow 20" in Canvas Tigresse',
          image: 'https://th3insid3.s3.amazonaws.com/tmp/phpmeBPJH/46su3a2nKQpjnvoCMBQiEJG6ta1K2OHQ5uoU9SbI.jpg',
        }
      },
      {
        id: 9,
        xCoordinate: 0.55,
        yCoordinate: 0.25,
        product: {
          id: 86250,
          link: 'https://www.theinside.com/products/slipcovered-bed-queen-sage-woodland-86250',
          title: 'Slipcovered Bed in Sage Woodland',
          image: 'https://th3insid3.s3.amazonaws.com/tmp/phpPFafOB/G0aNpgeimFF0C0f99X6cu39lKLFUwi6A04KPPyDm.jpg',
        }
      }]
  },
  {
    id: 6,
    image: 'stl-6.jpg',
    annotations: [{
      id: 10,
      xCoordinate: 0.6,
      yCoordinate: 0.75,
      product: {
        id: 963,
        link: '/products/hexagonal-ottoman-fawn-963',
        title: 'Hexagonal Ottoman in Fawn',
        image: 'https://theinside.imgix.net/products/FP4HFUqMJp2KVISIkXH3HZVRZ92IXPtSoQuxd1hB.jpg',
      }
    }]
  },
];
